import React from 'react'
import { openModal } from '../../../../../Library/ModalPopUp';
import { MessageFailedScore } from '../ScoringComponents';

export function HeaderBack({ totalWeight, HandlerBack }) {
    return (
        <div>
            <ul className="nav nav-tabs">
                <li className="nav-item">
                    <div
                        className="nav-link py-5 text-muted text-hover-primary cursor-pointer border-0"
                        title="Back"
                        onClick={() =>
                            totalWeight === 100 ? HandlerBack() : ConfirmLessWeight()
                        }
                    >
                        <i className="fas fa-angle-left"></i>
                    </div>
                </li>
                <li className="nav-item">
                    <div className="nav-link active">
                        <i className="flaticon-cogwheel-2"></i>
                        <span className="font-weight-bolder ml-2">
                            Assessment Instrument Setting
                        </span>
                    </div>
                </li>
            </ul>
        </div>
    )
}

const ConfirmLessWeight = () => {
    openModal({
        header: "",
        message: (
            <MessageFailedScore
                message={
                    "The total weight is less than 100%, please adjust and save it before leaving this page."
                }
            />
        ),
    });
};
